type InsightsReportSections = {
  cohorts: TODO[];
  filter: TODO[];
  formula: TODO[];
  group: TODO[];
  show: TODO[];
  time: TODO;
};

// Only the provided sections will be overridden
export type InsightsReportSectionsOverride = Partial<InsightsReportSections>;

export const ClauseType = {
  Cohorts: `cohorts`,
  Filter: `filter`,
  Formula: `formula`,
  Group: `group`,
  Show: `show`,
  Time: `time`,
} as const;

export const ClauseTypes = Object.values(ClauseType);

export type ClauseTypeEnum = (typeof ClauseType)[keyof typeof ClauseType];

export type DeserializeReturn<T extends {clauses: any}> = Pick<T, `clauses`>;
